import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input, OnInit } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as $ from 'jquery';
import firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { Http, Headers, RequestOptions } from '@angular/http';
import { LoadingProvider } from '../../../../../providers/loading/loading';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { ViewContactPage } from '../../../../view-contact/view-contact';
import { HomePage } from '../../../../home/home';
import { SdfFormService } from '../../../../../app/services/sdf-form-service';
//import { post } from 'jquery';
import { AngularFireStorage } from 'angularfire2/storage';
import { fromEvent, from } from 'rxjs';
import { debounceTime, take } from "rxjs/operators";
import { EnvDataService } from '../../../../../app/services/env-data-service';
import { DataService } from "../../../services/data.service";
declare var google;
@Component({
  selector: 'adf-dependent-details-form',
  templateUrl: 'dependent-details.html',
  providers: [EnvDataService]
})
export class DependentDetails implements OnInit {
  @Input() editdata: any;
  @Output() valueChange = new EventEmitter();

  slideTwoForm: FormGroup;

  userRole: any;
  new_val: any;
  old_val: any;
  applicant_details: any;
  allBrokers: any;
  applicant_type: any;
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  SDF_form_document_id: any;
  primary_uid: any;
  edit_contact_uid: any;
  deleted_access: any;
  public change_log_string: any;
  public dependents_family_details: any;
  public do_you_have_children_yes_or_no;
  public how_many_children_number;
  public showPrimaryApplicantFamily = 1;
  public showAdditionalFamily = -1;
  public children_age: any;

  public validation_messages = {
    'gender': [
      { type: 'required', message: 'Gender is required.' }
    ],
    'current_marital_status': [
      { type: 'required', message: 'Merital status is required.' }
    ],
    'do_you_have_children': [
      { type: 'required', message: 'Do you have children?' }
    ],
    'how_many_children': [
      { type: 'required', message: 'Enter How many dependents do you have under the age of 18?' }
    ],
    'first_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'second_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'third_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'fourth_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'fifth_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'sixth_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],

  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public db: AngularFirestore,
  ) {
    this.userRole = window.localStorage.getItem("userRole");
    this.applicant_details = '';
    this.getAllBrokers().subscribe((data) => {
      this.allBrokers = data;
    });
    this.applicant_type = "Primary";
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    let thiss = this;
    this.change_log_string = [];
    this.dependents_family_details = '';

    this.slideTwoForm = formBuilder.group({
      gender: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      current_marital_status: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      do_you_have_children: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      how_many_children: [''],
      first_child_age: [''],
      second_child_age: [''],
      third_child_age: [''],
      fourth_child_age: [''],
      fifth_child_age: [''],
      sixth_child_age: [''],
      addFamilyItem: formBuilder.array([])
    });


  }
  ngOnInit() {
    this.childrenCount();
  }

  ngOnChanges() {
    console.log('abc', this.editdata); // object here
    //console.log(this.slideTwoForm);
    if (this.editdata.contact_details != undefined) {
      if (this.editdata.contact_details.dependent != undefined) {
        var uData = this.editdata.contact_details.dependent;

        let howManyChildren = this.slideTwoForm.get('how_many_children');
        let firstChild = this.slideTwoForm.get('first_child_age');
        let secondChild = this.slideTwoForm.get('second_child_age');
        let thirdChild = this.slideTwoForm.get('third_child_age');
        let forthChild = this.slideTwoForm.get('fourth_child_age');
        let fifthChild = this.slideTwoForm.get('fifth_child_age');
        let sixthChild = this.slideTwoForm.get('sixth_child_age');

          if(uData.gender) {

            this.slideTwoForm.controls.gender.setValue((uData.gender != undefined) ? uData.gender : 'Male');
            this.slideTwoForm.controls.current_marital_status.setValue(uData.current_marital_status);
            this.slideTwoForm.controls.do_you_have_children.setValue(uData.do_you_have_children);
            if (uData.do_you_have_children == 'Yes') {
              this.do_you_have_children_yes_or_no = 'Yes';
              // howManyChildren.setValue(null);
              howManyChildren.setValidators(Validators.required);
              // firstChild.setValue(null);
              // secondChild.setValue(null);
              // thirdChild.setValue(null);
              // forthChild.setValue(null);
              // fifthChild.setValue(null);
              // sixthChild.setValue(null);
              //this.how_many_children_number = uData.contact_details.dependent.children_age.length;
            }else{

              howManyChildren.clearValidators();
              firstChild.clearValidators();
              secondChild.clearValidators();
              thirdChild.clearValidators();
              forthChild.clearValidators();
              fifthChild.clearValidators();
              sixthChild.clearValidators();
            }
            howManyChildren.updateValueAndValidity();
            firstChild.updateValueAndValidity();
            secondChild.updateValueAndValidity();
            thirdChild.updateValueAndValidity();
            forthChild.updateValueAndValidity();
            fifthChild.updateValueAndValidity();
            sixthChild.updateValueAndValidity();

            //12-04-2021
            this.slideTwoForm.controls.how_many_children.setValue(uData.how_many_children);
            if (uData.children_age.length > 0) {
              console.log('uData.children_age', uData.children_age)
              if (uData.children_age.length == 1) {
                this.slideTwoForm.controls.first_child_age.setValue(uData.children_age[0].age);
              } else if (uData.children_age.length == 2) {
                this.slideTwoForm.controls.first_child_age.setValue(uData.children_age[0].age);
                this.slideTwoForm.controls.second_child_age.setValue(uData.children_age[1].age);
              } else if (uData.children_age.length == 3) {
                this.slideTwoForm.controls.first_child_age.setValue(uData.children_age[0].age);
                this.slideTwoForm.controls.second_child_age.setValue(uData.children_age[1].age);
                this.slideTwoForm.controls.third_child_age.setValue(uData.children_age[2].age);
              } else if (uData.children_age.length == 4) {
                this.slideTwoForm.controls.first_child_age.setValue(uData.children_age[0].age);
                this.slideTwoForm.controls.second_child_age.setValue(uData.children_age[1].age);
                this.slideTwoForm.controls.third_child_age.setValue(uData.children_age[2].age);
                this.slideTwoForm.controls.fourth_child_age.setValue(uData.children_age[3].age);
              } else if (uData.children_age.length == 5) {
                this.slideTwoForm.controls.first_child_age.setValue(uData.children_age[0].age);
                this.slideTwoForm.controls.second_child_age.setValue(uData.children_age[1].age);
                this.slideTwoForm.controls.third_child_age.setValue(uData.children_age[2].age);
                this.slideTwoForm.controls.fourth_child_age.setValue(uData.children_age[3].age);
                this.slideTwoForm.controls.fifth_child_age.setValue(uData.children_age[4].age);
              } else if (uData.children_age.length == 6) {
                this.slideTwoForm.controls.first_child_age.setValue(uData.children_age[0].age);
                this.slideTwoForm.controls.second_child_age.setValue(uData.children_age[1].age);
                this.slideTwoForm.controls.third_child_age.setValue(uData.children_age[2].age);
                this.slideTwoForm.controls.fourth_child_age.setValue(uData.children_age[3].age);
                this.slideTwoForm.controls.fifth_child_age.setValue(uData.children_age[4].age);
                this.slideTwoForm.controls.sixth_child_age.setValue(uData.children_age[5].age);
              }

            }

            this.how_many_children_number = parseInt(uData.how_many_children, 10);
            this.children_age = uData.children_age;

          }

      }

    }

  }

  addAnotherApplicant() {
    this.formApplicantFamily.push(this.initaddAnotherApplicantFamily());
  }

  editgetSDFUser(SDF_form_document_id, uid) {
    if (this.userRole == "super_admin" && this.deleted_access == 1) {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).orderBy('created_date', 'asc')).valueChanges();
    } else {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).where('deleted', '==', 0).orderBy('created_date', 'asc')).valueChanges();
    }
  }

  getAllBrokers() {
    return this.db.collection<any>("users", ref => ref.where('roles.broker', '==', true)).valueChanges();
  }

  get formApplicantFamily() {
    return this.slideTwoForm.get('addFamilyItem') as FormArray;
  }



  childrenCount() {
    let howManyChildren = this.slideTwoForm.get('how_many_children');
    let firstChild = this.slideTwoForm.get('first_child_age');
    let secondChild = this.slideTwoForm.get('second_child_age');
    let thirdChild = this.slideTwoForm.get('third_child_age');
    let forthChild = this.slideTwoForm.get('fourth_child_age');
    let fifthChild = this.slideTwoForm.get('fifth_child_age');
    let sixthChild = this.slideTwoForm.get('sixth_child_age');
    howManyChildren.valueChanges
      .subscribe(child => {
        if (child == 0) {
          secondChild.setValidators(null);
          thirdChild.setValidators(null);
          forthChild.setValidators(null);
          fifthChild.setValidators(null);
          sixthChild.setValidators(null);
          firstChild.setValidators(null);
        }
        if (child == 1) {
          secondChild.setValidators(null);
          thirdChild.setValidators(null);
          forthChild.setValidators(null);
          fifthChild.setValidators(null);
          sixthChild.setValidators(null);
          firstChild.setValidators(Validators.required);
        }
        if (child == 2) {
          thirdChild.setValidators(null);
          forthChild.setValidators(null);
          fifthChild.setValidators(null);
          sixthChild.setValidators(null);
          firstChild.setValidators(Validators.required);
          secondChild.setValidators(Validators.required);
        }
        if (child == 3) {
          forthChild.setValidators(null);
          fifthChild.setValidators(null);
          sixthChild.setValidators(null);
          firstChild.setValidators(Validators.required);
          secondChild.setValidators(Validators.required);
          thirdChild.setValidators(Validators.required);
        }
        if (child == 4) {
          fifthChild.setValidators(null);
          sixthChild.setValidators(null);
          firstChild.setValidators(Validators.required);
          secondChild.setValidators(Validators.required);
          thirdChild.setValidators(Validators.required);
          forthChild.setValidators(Validators.required);
        }
        if (child == 5) {
          sixthChild.setValidators(null);
          firstChild.setValidators(Validators.required);
          secondChild.setValidators(Validators.required);
          thirdChild.setValidators(Validators.required);
          forthChild.setValidators(Validators.required);
          fifthChild.setValidators(Validators.required);
        }
        if (child == 6) {
          firstChild.setValidators(Validators.required);
          secondChild.setValidators(Validators.required);
          thirdChild.setValidators(Validators.required);
          forthChild.setValidators(Validators.required);
          fifthChild.setValidators(Validators.required);
          sixthChild.setValidators(Validators.required);
        }
        firstChild.updateValueAndValidity();
        secondChild.updateValueAndValidity();
        thirdChild.updateValueAndValidity();
        forthChild.updateValueAndValidity();
        fifthChild.updateValueAndValidity();
        sixthChild.updateValueAndValidity();
      });
    //this.signupSlider.resize();
    //this.signupSlider.update();
  }

  changeLog(event, index: any) {
    // let this = this;
    // var property = event.ngControl.name;
    // this.new_val = event._value;
    // this.old_val = '';
    // var new_property = '';

    // if(index == 'main'){
    //   if(property == 'firstname'){
    //     this.old_val = (this.applicant_details.firstname == undefined) ? '' : this.applicant_details.firstname;
    //     new_property = 'Firstname';
    //     this.firstname = this.new_val;
    //   }
    //   if(property == 'middlename'){
    //     this.old_val = (this.applicant_details.middlename == undefined) ? '' : this.applicant_details.middlename;
    //     new_property = 'Middlename';
    //   }
    //   if(property == 'lastname'){
    //     this.old_val = (this.applicant_details.lastname == undefined) ? '' : this.applicant_details.lastname;
    //     new_property = 'Lastname';
    //     this.lastname = this.new_val;
    //   }
    //   if(property == 'email'){
    //     this.old_val = (this.applicant_details.email == undefined) ? '' : this.applicant_details.email;
    //     new_property = 'Email';
    //     this.checkContact = 0;
    //     firebase.firestore().collection("users").where("email", "==", this.new_val).get()
    //     .then(function(querySnapshot) {
    //       querySnapshot.forEach(function(priCon) {
    //         if(priCon.data().roles.contact == true){
    //           this.checkContact = 0;
    //         }else{
    //           this.checkContact = 1;
    //         }
    //       })
    //     })
    //     this.signupSlider.resize();
    //     this.signupSlider.update();
    //   }
    //   if(property == 'mobile_phone'){
    //     this.old_val = (this.applicant_details.mobile_phone == undefined) ? '' : this.applicant_details.mobile_phone;
    //     new_property = 'Mobile Phone';
    //   }
    //   if(property == 'primayr_goal_intention'){
    //     this.old_val = (this.applicant_details.primayr_goal_intention == undefined) ? '' : this.applicant_details.primayr_goal_intention;
    //     new_property = 'Primary Goal Intention';
    //   }
    //   if(property == 'floor_number'){
    //     this.old_val = (this.applicant_details.floor_number == undefined) ? '' : this.applicant_details.floor_number;
    //     new_property = 'Floor Number';
    //   }
    //   if(property == 'unit_number'){
    //     this.old_val = (this.applicant_details.unit_number == undefined) ? '' : this.applicant_details.unit_number;
    //     new_property = 'Unit Number';
    //   }
    //   if(property == 'building_name'){
    //     this.old_val = (this.applicant_details.building_name == undefined) ? '' : this.applicant_details.building_name;
    //     new_property = 'Building Name';
    //   }
    //   if(property == 'street_number'){
    //     this.old_val = (this.applicant_details.street_number == undefined) ? '' : this.applicant_details.street_number;
    //     new_property = 'Street Number';
    //   }
    //   if(property == 'street_name'){
    //     this.old_val = (this.applicant_details.street_name == undefined) ? '' : this.applicant_details.street_name;
    //     new_property = 'Street Name';
    //   }
    //   if(property == 'city'){
    //     this.old_val = (this.applicant_details.city == undefined) ? '' : this.applicant_details.city;
    //     new_property = 'City';
    //   }
    //   if(property == 'postcode'){
    //     this.old_val = (this.applicant_details.postcode == undefined) ? '' : this.applicant_details.postcode;
    //     new_property = 'Postcode';
    //   }
    //   if(property == 'poboxlabel'){
    //     this.old_val = (this.applicant_details.poboxlabel == undefined) ? '' : this.applicant_details.poboxlabel;
    //     new_property = 'PO Box Label';
    //   }
    //   if(property == 'first_child_age'){
    //     this.old_val = (this.applicant_details.first_child_age == undefined) ? '' : this.applicant_details.first_child_age;
    //     new_property = 'First Child Age';
    //   }
    //   if(property == 'second_child_age'){
    //     this.old_val = (this.applicant_details.second_child_age == undefined) ? '' : this.applicant_details.second_child_age;
    //     new_property = 'Second Child Age';
    //   }
    //   if(property == 'third_child_age'){
    //     this.old_val = (this.applicant_details.third_child_age == undefined) ? '' : this.applicant_details.third_child_age;
    //     new_property = 'Third Child Age';
    //   }
    //   if(property == 'fourth_child_age'){
    //     this.old_val = (this.applicant_details.fourth_child_age == undefined) ? '' : this.applicant_details.fourth_child_age;
    //     new_property = 'Fourth Child Age';
    //   }
    //   if(property == 'fifth_child_age'){
    //     this.old_val = (this.applicant_details.fifth_child_age == undefined) ? '' : this.applicant_details.fifth_child_age;
    //     new_property = 'Fifth Child Age';
    //   }
    //   if(property == 'sixth_child_age'){
    //     this.old_val = (this.applicant_details.sixth_child_age == undefined) ? '' : this.applicant_details.sixth_child_age;
    //     new_property = 'Sixth Child Age';
    //   }
    //   if(property == 'your_occupation'){
    //     this.old_val = (this.employment_details.your_occupation == undefined) ? '' : this.employment_details.your_occupation;
    //     new_property = 'Your Occupation';
    //   }
    //   if(property == 'start_date'){
    //     this.old_val = (this.employment_details.start_date == undefined) ? '' : this.employment_details.start_date;
    //     new_property = 'Employment start date';
    //   }
    //   if(property == 'business_name'){
    //     this.old_val = (this.employment_details.business_name == undefined) ? '' : this.employment_details.business_name;
    //     new_property = 'Business Name';
    //   }
    //   if(property == 'type_of_entity'){
    //     this.old_val = (this.employment_details.type_of_entity == undefined) ? '' : this.employment_details.type_of_entity;
    //     new_property = 'Type of Entity';
    //   }
    //   if(property == 'abn_acn'){
    //     this.old_val = (this.employment_details.abn_acn == undefined) ? '' : this.employment_details.abn_acn;
    //     new_property = 'abn_acn';
    //   }
    //   if(property == 'nature_of_business'){
    //     this.old_val = (this.employment_details.nature_of_business == undefined) ? '' : this.employment_details.nature_of_business;
    //     new_property = 'Nature of Business';
    //   }
    // }else{
    //   if(property == 'secondary_email'){
    //     this.old_val = (this.secondary_details.secondary_email == undefined) ? '' : this.secondary_details.secondary_email;
    //     new_property = 'Email';
    //     this.checkAddiContact.push({'status': 0});
    //     this.checkAddiContact[index].status = 0;
    //     this.checkAddiContactStatus = 0;
    //     firebase.firestore().collection("users").where("email", "==", this.new_val).get()
    //     .then(function(querySnapshot) {
    //       querySnapshot.forEach(function(priCon) {
    //         if(priCon.data().roles.contact == true){
    //           this.checkAddiContact[index].status = 0;
    //         }else{
    //           this.checkAddiContact[index].status = 1;
    //           this.checkAddiContactStatus = 1;
    //         }
    //       })
    //     })
    //     this.signupSlider.resize();
    //     this.signupSlider.update();
    //   }

    // }



    // if(this.new_val != this.old_val){
    //   //this.change_log_string += property+'='+this.old_val+':'+this.new_val+';';
    //   this.change_log_string.push({'property' : new_property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': index, 'index2': index});
    // }
  }
  collectLogData(event, type, index) {
    this.new_val = event.target.value;
    this.old_val = '';
    var property = '';
    if (type == 'address_type') {
      this.old_val = (this.applicant_details.address_type == undefined) ? '' : this.applicant_details.address_type;
      property = 'Address Type';
    }
    if (type == 'street_type') {
      this.old_val = (this.applicant_details.street_type == undefined) ? '' : this.applicant_details.street_type;
      property = 'Street Type';
    }
    if (type == 'state') {
      this.old_val = (this.applicant_details.state == undefined) ? '' : this.applicant_details.state;
      property = 'State';
    }
    if (type == 'country') {
      this.old_val = (this.applicant_details.country == undefined) ? '' : this.applicant_details.country;
      property = 'Country';
    }
    if (type == 'housing_situation') {
      this.old_val = (this.applicant_details.housing_situation == undefined) ? '' : this.applicant_details.housing_situation;
      property = 'Housing Situation';
    }
    if (type == 'move_in_date') {
      this.old_val = (this.applicant_details.move_in_date == undefined) ? '' : this.applicant_details.move_in_date;
      property = 'Move in Date';
    }
    if (type == 'date_of_birth') {
      this.old_val = (this.applicant_details.date_of_birth == undefined) ? '' : this.applicant_details.date_of_birth;
      property = 'Date of Birth';
    }
    if (this.new_val != this.old_val) {
      this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': index, 'index2': index });
    }
    console.log('this.change_log_string', this.change_log_string)
  }

  public changeDoYouHaveChild($event, type, index) {
    debugger;
    if (index == 'main') {
      this.do_you_have_children_yes_or_no = $event;
    } else {
      this.setSecondaryChilderValue(index);
    }

    //12-04-2021

    let hasChild= this.slideTwoForm.get('do_you_have_children');
    let howManyChildren = this.slideTwoForm.get('how_many_children');
    let firstChild = this.slideTwoForm.get('first_child_age');
    let secondChild = this.slideTwoForm.get('second_child_age');
    let thirdChild = this.slideTwoForm.get('third_child_age');
    let forthChild = this.slideTwoForm.get('fourth_child_age');
    let fifthChild = this.slideTwoForm.get('fifth_child_age');
    let sixthChild = this.slideTwoForm.get('sixth_child_age');

    if(this.do_you_have_children_yes_or_no == "Yes"){

      howManyChildren.setValue(null);
      howManyChildren.setValidators(Validators.required);
      firstChild.setValue(null);
      secondChild.setValue(null);
      thirdChild.setValue(null);
      forthChild.setValue(null);
      fifthChild.setValue(null);
      sixthChild.setValue(null);

    }else{

      howManyChildren.clearValidators();
      firstChild.clearValidators();
      secondChild.clearValidators();
      thirdChild.clearValidators();
      forthChild.clearValidators();
      fifthChild.clearValidators();
      sixthChild.clearValidators();
    }
    howManyChildren.updateValueAndValidity();
    firstChild.updateValueAndValidity();
    secondChild.updateValueAndValidity();
    thirdChild.updateValueAndValidity();
    forthChild.updateValueAndValidity();
    fifthChild.updateValueAndValidity();
    sixthChild.updateValueAndValidity();

    //this.signupSlider.resize();
    //this.signupSlider.update();
    if ($event == undefined) {
      return false;
    }
    this.new_val = $event;
    this.old_val = '';
    var property = '';
    if (index == 'main') {
      if (type == 'do_you_have_children') {
        this.old_val = (this.applicant_details.do_you_have_children == undefined) ? '' : this.applicant_details.do_you_have_children;
        property = 'Do You Have Children';
      }
    }
    if (this.new_val != this.old_val) {
      //this.change_log_string += type+'='+this.old_val+':'+this.new_val+';';
      this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': index, 'index2': index });
    }
  }

  setSecondaryChilderValue(index) {
    debugger;
    let hasChild = this.formApplicantFamily.controls[index].get('do_you_have_children').value;
    let howManyChildren = this.formApplicantFamily.controls[index].get('how_many_children');
    let firstChild = this.formApplicantFamily.controls[index].get('first_child_age');
    let secondChild = this.formApplicantFamily.controls[index].get('second_child_age');
    let thirdChild = this.formApplicantFamily.controls[index].get('third_child_age');
    let forthChild = this.formApplicantFamily.controls[index].get('fourth_child_age');
    let fifthChild = this.formApplicantFamily.controls[index].get('fifth_child_age');
    let sixthChild = this.formApplicantFamily.controls[index].get('sixth_child_age');
    if (hasChild == 'No') {
      // howManyChildren.setValidators(null);
      // firstChild.setValidators(null);
      // secondChild.setValidators(null);
      // thirdChild.setValidators(null);
      // forthChild.setValidators(null);
      // fifthChild.setValidators(null);
      // sixthChild.setValidators(null);

      howManyChildren.clearValidators();
      firstChild.clearValidators();
      secondChild.clearValidators();
      thirdChild.clearValidators();
      forthChild.clearValidators();
      fifthChild.clearValidators();
      sixthChild.clearValidators();
    }
    if (hasChild == 'Yes') {
      howManyChildren.setValue(null);
      howManyChildren.setValidators(Validators.required);
      firstChild.setValue(null);
      secondChild.setValue(null);
      thirdChild.setValue(null);
      forthChild.setValue(null);
      fifthChild.setValue(null);
      sixthChild.setValue(null);
    }
    howManyChildren.updateValueAndValidity();
    firstChild.updateValueAndValidity();
    secondChild.updateValueAndValidity();
    thirdChild.updateValueAndValidity();
    forthChild.updateValueAndValidity();
    fifthChild.updateValueAndValidity();
    sixthChild.updateValueAndValidity();

    //this.signupSlider.resize();
    //this.signupSlider.update();
  }

  codeInput(event) {
    //48 - 57
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

  public changeHowManyChildren($event, type, index) {
    if (index == 'main') {
      this.how_many_children_number = $event._value;
    } else {
      this.secondaryChildrenCount(index)
    }
    //this.signupSlider.resize();
    //this.signupSlider.update();
    this.new_val = $event._value;
    this.old_val = '';
    var property = '';
    if (index == 'main') {
      if (type == 'how_many_children') {
        this.old_val = (this.applicant_details.how_many_children == undefined) ? '' : this.applicant_details.how_many_children;
        property = 'How Many Children';
      }
    }
    if (this.new_val != this.old_val) {
      //this.change_log_string += type+'='+this.old_val+':'+this.new_val+';';
      this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': index, 'index2': index });
    }
  }

  secondaryChildrenCount(index) {
    let child = this.formApplicantFamily.controls[index].get('how_many_children').value;
    let firstChild = this.formApplicantFamily.controls[index].get('first_child_age');
    let secondChild = this.formApplicantFamily.controls[index].get('second_child_age');
    let thirdChild = this.formApplicantFamily.controls[index].get('third_child_age');
    let forthChild = this.formApplicantFamily.controls[index].get('fourth_child_age');
    let fifthChild = this.formApplicantFamily.controls[index].get('fifth_child_age');
    let sixthChild = this.formApplicantFamily.controls[index].get('sixth_child_age');
    if (child == 0) {
      secondChild.setValidators(null);
      thirdChild.setValidators(null);
      forthChild.setValidators(null);
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
      firstChild.setValidators(null);
    }
    if (child == 1) {
      secondChild.setValidators(null);
      thirdChild.setValidators(null);
      forthChild.setValidators(null);
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
      firstChild.setValidators(Validators.required);
    }
    if (child == 2) {
      thirdChild.setValidators(null);
      forthChild.setValidators(null);
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
      firstChild.setValidators(Validators.required);
      secondChild.setValidators(Validators.required);
    }
    if (child == 3) {
      forthChild.setValidators(null);
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
      firstChild.setValidators(Validators.required);
      secondChild.setValidators(Validators.required);
      thirdChild.setValidators(Validators.required);
    }
    if (child == 4) {
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
      firstChild.setValidators(Validators.required);
      secondChild.setValidators(Validators.required);
      thirdChild.setValidators(Validators.required);
      forthChild.setValidators(Validators.required);
    }
    if (child == 5) {
      sixthChild.setValidators(null);
      firstChild.setValidators(Validators.required);
      secondChild.setValidators(Validators.required);
      thirdChild.setValidators(Validators.required);
      forthChild.setValidators(Validators.required);
      fifthChild.setValidators(Validators.required);
    }
    if (child == 6) {
      firstChild.setValidators(Validators.required);
      secondChild.setValidators(Validators.required);
      thirdChild.setValidators(Validators.required);
      forthChild.setValidators(Validators.required);
      fifthChild.setValidators(Validators.required);
      sixthChild.setValidators(Validators.required);
    }
    firstChild.updateValueAndValidity();
    secondChild.updateValueAndValidity();
    thirdChild.updateValueAndValidity();
    forthChild.updateValueAndValidity();
    fifthChild.updateValueAndValidity();
    sixthChild.updateValueAndValidity();

    //this.signupSlider.resize();
    //this.signupSlider.update();
  }

  test() {
    alert('hi')
  }



  initaddAnotherApplicantFamily() {
    return this.formBuilder.group({
      gender: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      current_marital_status: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      do_you_have_children: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      how_many_children: [null, [Validators.required]],
      first_child_age: [null, [Validators.required]],
      second_child_age: [null, [Validators.required]],
      third_child_age: [null, [Validators.required]],
      fourth_child_age: [null, [Validators.required]],
      fifth_child_age: [null, [Validators.required]],
      sixth_child_age: [null, [Validators.required]]
    });
  }

  getValue() {
    //this.additionalForm.get
    console.log(this.slideTwoForm.value);
    //console.log(this.formArrApplicantAddress.controls.city.value;
    this.valueChange.emit(this.slideTwoForm.value);

  }
}




// WEBPACK FOOTER //
// ./src/pages/edit-contact-form-list/component/dependent-and-family/dependent-details/dependent-details.ts